import React, { FC } from 'react';
import SearchSecondaryBar from './SearchSecondaryBar';

const SearchSecondaryBarLazy: FC<{ isPublishUserSelection: boolean }> = ({ isPublishUserSelection = false }) => {
  return (
    //<ErrorBoundary>
    // <Suspense fallback={''}>
    <SearchSecondaryBar isPublishUserSelection={isPublishUserSelection} />
    // {/* </Suspense> */}
    // {/* </ErrorBoundary> */}
  );
};

export default SearchSecondaryBarLazy;
